import { useNavigate } from "react-router-dom";
import FAIcon from "../FAIcon/FAIcon";
import { useLang } from "../../../utils/lang";


interface Props {
    url: string;
}
const BackArrow = (props: Props) => {
    const navigate = useNavigate();
    const lang = useLang();
    return (
        <div style={{ marginRight: '1rem' }}>
            <FAIcon prefix='fad' name='arrow-left' style={{ cursor: 'pointer' }} onClick={() => navigate(`/${lang}/${props.url}`)} />
        </div>
    );
};

export default BackArrow;